import { fetchVenuePosIntegrationStatus } from 'apis/restaurant-api/merchant-admin/venue/api';

const venuePosIntegrationStatus = async (venueId: string) => {
  try {
    const posIntegrationStatus = await fetchVenuePosIntegrationStatus(venueId);
    return posIntegrationStatus;
  } catch (error) {
    if (error.response?.status === 404) {
      return { is_pos_integrated: false, is_menu_integrated: false };
    }
    return null;
  }
};

export default venuePosIntegrationStatus;
